/* Progressive enhancement: content stays visible without JavaScript or observers. */
if (!customElements.get('pf-home-motion')) {
  customElements.define('pf-home-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || !document.body.classList.contains('pf-modern')) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Set();
      const animate = (element, frames, timing) => {
        if (preference.matches || !element.animate) return;
        const animation = element.animate(frames, timing);
        this.animations.add(animation);
        animation.onfinish = () => this.animations.delete(animation);
      };
      preference.addEventListener('change', () => {
        if (preference.matches) this.animations.forEach(animation => animation.cancel());
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            animate(entry.target, [{ opacity: 0, transform: 'translateY(22px)' }, { opacity: 1, transform: 'none' }], {
              duration: 650, delay: Number(entry.target.dataset.motionDelay || 0), easing: 'ease-out', fill: 'backwards'
            });
          });
        }, { threshold: 0.08 });
        this.querySelectorAll('.pfe-section-head, .pfe-collection, .pfe-feature, .pfe-showrooms, .pfe-brand-note, .pfe-reviews').forEach(element => {
          if (element.classList.contains('pfe-collection')) {
            element.dataset.motionDelay = [...element.parentElement.children].indexOf(element) % 4 * 80;
          }
          this.observer.observe(element);
        });
      }
      this.querySelectorAll('.pfe-feature').forEach(feature => {
        const image = feature.querySelector('.pfe-feature-image img');
        const details = [...feature.querySelectorAll('[data-feature-src]')];
        if (!image || !details.length) return;
        let selected;
        const select = detail => {
          if (selected === detail) return;
          selected = detail;
          details.forEach(other => { other.open = other === detail; });
          feature.dataset.featureActive = detail.dataset.featureIndex;
          image.removeAttribute('srcset');
          image.src = detail.dataset.featureSrc;
          image.alt = detail.dataset.featureAlt;
          animate(image, [{ opacity: 0.3 }, { opacity: 1 }], { duration: 500 });
          const description = detail.querySelector('p');
          if (description) animate(description, [{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 300 });
        };
        details.forEach(detail => detail.addEventListener('toggle', () => { if (detail.open) select(detail); }, options));
        select(details.find(detail => detail.open) || details[0]);
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.controller = null;
    }
  });
}
